import { Outlet } from "react-router-dom";

const Subscriptions = () => {
  return <Outlet />;
};
export default Subscriptions;
